export default __webpack_public_path__ + "static/media/solucao-01.0b583850.webp";